import {
	AboutUsRoute,
	BecomeAPartnerRoute,
	FAQsRoute,
	GiveawaysRoute,
	MerchRoute,
	WinnersRoute,
} from "@/features/home/route";
import {
	PrivacyPolicyRoute,
	TermsAndConditionsRoute,
} from "@/features/legal-information/route";
import FooterButton from "../components/footer-button";
import { useIsMobile } from "../hooks/use-mobile";
import FacebookIcon from "../svgs/facebook";
import InstagramIcon from "../svgs/instagram";
import LogoIcon from "../svgs/logo";
import MailIcon from "../svgs/mail";
import YoutubeIcon from "../svgs/youtube";

function Footer() {
	const isMobile = useIsMobile();

	const supportEmailClass = isMobile
		? "web-body-b1-medium font-bold text-white"
		: "web-body-b2 font-bold text-white";

	const backgroundStyles = {
		backgroundImage:
			"linear-gradient(to bottom, #004096, #470096),radial-gradient(circle at 0% -5%,rgba(46, 219, 202, 0.3),rgba(8, 50, 46, 0))",
		backgroundBlendMode: "lighten",
	};

	return (
		<div className="relative" style={backgroundStyles}>
			<div className="z-10 px-4 py-24 md:px-37 md:py-12 md:pt-25">
					<div className="grid grid-cols-1 items-end md:grid-cols-5">
						<div className="max-sm:mb-12 max-sm:flex max-sm:justify-center">
							<LogoIcon
								height={isMobile ? 100 : 140}
								width={isMobile ? 100 : 134}
							/>
						</div>

						<div className="col-span-3 col-start-1 grid grid-cols-3 gap-y-12 md:col-start-2">
							<FooterButton url={AboutUsRoute} title="About us" />
							<FooterButton url={WinnersRoute} title="Previous Winners" />
							<FooterButton url={FAQsRoute} title="FAQs" />
						<FooterButton url={BecomeAPartnerRoute} title="Partners" />
						<FooterButton url={GiveawaysRoute} title="Giveaways" />
						<FooterButton url={MerchRoute} title="Store" />
					</div>
					</div>

				<div className="bg-light-gray mt-12 h-[1px] w-full opacity-30 md:mt-25 md:mb-8" />

				<div className="flex flex-col">
					<div className="flex flex-col justify-between md:flex-row">
						<div className="flex flex-col md:w-2/5 md:flex-row md:gap-8">
							<div className="flex flex-row gap-5 max-sm:mt-12">
								<YoutubeIcon />
								<FacebookIcon />
								<InstagramIcon />
							</div>
							<div className="flex flex-row gap-2 max-sm:my-12">
								<MailIcon />
								<p className={supportEmailClass}>support@reelrewards.com.au</p>
							</div>
						</div>

						<div className="flex flex-col gap-8 md:flex-row">
							<FooterButton url={PrivacyPolicyRoute} title="Privacy Policy" />
							<FooterButton
								url={TermsAndConditionsRoute}
								title="Terms And Conditions"
							/>
							<FooterButton title="ABN (90 681 746 412)" />
							<FooterButton title="© 2025 All Rights Reserved" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default Footer;
